import config from "config/config";
import moment from "moment/moment";
import { v4 as uuidv4 } from "uuid";
import { useState } from "react";
import { useForm } from "react-hook-form";

import { Link } from "react-router-dom";
import { stringFormatingToPascal } from "js/formatting";
import { validateUserInODS } from "service/userservice/validateUserInODS";
import useTrackUnsuccessfulODSRegistrationValidation from "logging/hooks/useTrackUnsuccessfulODSRegistrationValidation";

import FormInputError from "components/General/FormInputError";
import DomainErrorModal from "components/ModalDialogs/DomainErrorModal";
import SSNInput from "components/General/Form/SSNInput";
import MaskedPhoneNumberInput from "components/General/Form/MaskedPhoneNumberInput";
import { Trans, useTranslation } from "react-i18next";

const PanelOne = ({
  customerRegistrationFormData,
  setCustomerRegistrationFormData,
  setCurrentStep,
  setRoleId,
  setLoading,
}) => {
  const uuid = uuidv4();
  const { t } = useTranslation();
  const trackUnsuccessfulODSRegistrationValidation =
    useTrackUnsuccessfulODSRegistrationValidation();

  const [policyHolder, setPolicyHolder] = useState("individual");
  const [errorInfo, seterrorInfo] = useState("");
  const [errorTitle, setErrorTitle] = useState("");

  const [modalState, setModalState] = useState(false);
  const [domainError, setDomainError] = useState(0);
  const [checkBox, setCheckBox] = useState(false);
  const onOptionChange = (e) => setPolicyHolder(e.target.value);

  const {
    register: registrationPanelOneRegister,
    handleSubmit,
    setValue: registrationPanelOneSetValue,
    formState: { errors: registrationPanelOneErrors },
  } = useForm({
    defaultValues: customerRegistrationFormData,
  });

  async function onSubmit(data) {
    if (
      window.localStorage.getItem("CustRegCount") &&
      parseInt(window.localStorage.getItem("CustRegCount")) >=
        parseInt(config.REGISTRATION_COUNTER) &&
      Date.now() - window.localStorage.getItem("CustRegCounterDate") <
        24 * 60 * 60 * 1000
    ) {
      seterrorInfo(t("CustomerRegister-step-1-form-error-1"));
      setModalState(true);
    } else {
      data.firstname = stringFormatingToPascal(data.firstname);
      data.lastname = stringFormatingToPascal(data.lastname);
      setLoading(true);
      let result = await validateUserInODS(
        data.policyNumber.toUpperCase().trim(),
        data.policyOwnerType === "individual"
          ? data.firstname?.trim()
          : data.businessName?.trim(),
        data.lastname?.trim(),
        data.policyOwnerType === "individual"
          ? data.ssn
          : data.socialSecurity_EIN,
        data.zipCode?.trim() || "",
        data.phoneNumber?.trim(),
        data.dob ? moment(data.dob).format("MM/DD/YYYY") : ""
      ).catch((error) => {
        console.error(error);
      });

      setLoading(false);
      if (result.status === undefined) {
        let user = result;
        data.userEmail = user.emailId;
        data.email = user.emailId;
        data.confirmEmail = user.emailId;
        data.oldPolicyId = user.oldPolicyId;
        data.contractId = user.contractId;
        data.identityNumber = user.identityNumber;
        data.paperless = user.paperlessSetting;
        data.defaultpaperless = user.paperlessSetting;
        data.ownerType = user.ownerType;
        data.taxType = user.taxType;
        setRoleId(user.roleId);
        setCustomerRegistrationFormData((curr) => ({
          ...curr,
          ...data,
        }));
        window.localStorage.removeItem("CustRegCount");
        window.localStorage.removeItem("CustRegCounterDate");
        if (user.cautionMessage !== "") {
          setDomainError(1);
          seterrorInfo(user.cautionMessage);
          setModalState(true);
        } else {
          setCurrentStep(2);
        }
      } else {
        if (window.localStorage.getItem("CustRegCount")) {
          if (
            Date.now() - window.localStorage.getItem("CustRegCounterDate") >
            24 * 60 * 60 * 1000
          ) {
            window.localStorage.setItem("CustRegCounterDate", Date.now());
            window.localStorage.setItem("CustRegCount", 1);
          } else {
            window.localStorage.setItem(
              "CustRegCount",
              parseInt(window.localStorage.getItem("CustRegCount")) + 1
            );
          }
        } else {
          window.localStorage.setItem("CustRegCounterDate", Date.now());
          window.localStorage.setItem("CustRegCount", 1);
        }

        trackUnsuccessfulODSRegistrationValidation({
          status: result.status,
          policyNumber: data.policyNumber,
          firstname: data.firstname,
          lastname: data.lastname,
          businessName: data.businessName,
          zipCode: data.zipCode,
          phoneNumber: data.phoneNumber,
          dob: data.dob,
          taxType: data.taxType,
        });

        if (result.status === 403) {
          switch (result?.title) {
            case "RestrictedPolicy":
              seterrorInfo(
                <Trans
                  i18nKey="CustomerRegister-step-1-form-error-message"
                  components={{
                    link1: (
                      <Link
                        to="/guest/help"
                        className="text-ui-blue underline"
                      />
                    ),
                  }}
                />
              );
              setErrorTitle(t("CustomerRegister-step-1-form-error-title"));
              break;
            case "DomesticViolenceCasePolicy":
              seterrorInfo(
                t(
                  "CustomerRegister-step-1-form-domestic-violence-error-message"
                )
              );
              setErrorTitle(
                t("CustomerRegister-step-1-form-domestic-violence-error-title")
              );
              break;
            case "AlreadyRegisteredPolicy":
              setErrorTitle(
                t("CustomerRegister-user-already-registered-error-title")
              );
              seterrorInfo(
                t("CustomerRegister-user-already-registered-error-description")
              );
              break;
            case "DeathClaimReportedPolicy":
              setErrorTitle(
                t("CustomerRegister-step-1-form-death-claim-error-title")
              );
              seterrorInfo(
                <Trans
                  i18nKey="CustomerRegister-step-1-form-death-claim-error-message"
                  components={{
                    link1: (
                      <Link
                        to="/guest/help"
                        className="text-ui-blue underline"
                      />
                    ),
                  }}
                />
              );
              break;
            default:
              seterrorInfo(result.title);
              break;
          }
          setModalState(true);
        } else if (result.status === 401) {
          seterrorInfo(result.title);
          setModalState(true);
        } else if (result.status === 404) {
          seterrorInfo(
            t("CustomerRegister-step-1-form-error-2", {
              email: config.CUSTOMER_SERVICE_EMAIL,
            })
          );
          setErrorTitle(
            t("CustomerRegister-step-1-form-policy-not-found-error")
          );
          setModalState(true);
        }
      }
    }
  }

  return (
    <>
      <div className="mt-4">
        <form onSubmit={handleSubmit(onSubmit)}>
          <fieldset className="flex">
            <label className="text-sm font-normal mr-4">
              {t("CustomerRegister-step-1-formHeading-1")}
            </label>

            <div>
              <div className="inline-block mr-6">
                <label className="inline-flex items-center text-sm font-normal">
                  <input
                    type="radio"
                    value="individual"
                    checked={policyHolder === "individual"}
                    onClick={onOptionChange}
                    className="mr-2"
                    {...registrationPanelOneRegister("policyOwnerType", {
                      required: t("CustomerRegister-step-1-form-error-3"),
                    })}
                  />
                  {t("CustomerRegister-step-1-form-label-1")}
                </label>
              </div>
              <div className="inline-block">
                <label className="inline-flex items-center text-sm font-normal">
                  <input
                    type="radio"
                    value="entity"
                    checked={policyHolder === "entity"}
                    onClick={onOptionChange}
                    className="mr-2"
                    {...registrationPanelOneRegister("policyOwnerType", {
                      required: t("CustomerRegister-step-1-form-error-3"),
                    })}
                  />
                  {t("CustomerRegister-step-1-form-label-2")}
                </label>
              </div>
            </div>
          </fieldset>
          {registrationPanelOneErrors.policyOwnerType && (
            <FormInputError
              id={`${uuid}-policyOwnerType-error`}
              errorMessage={registrationPanelOneErrors.policyOwnerType.message}
            />
          )}

          <hr />

          <div className="mb-6">
            <label
              htmlFor={`${uuid}-customer-policyNumber-id`}
              className="text-base font-semibold"
            >
              {t("CustomerRegister-step-1-form-label-3")}
            </label>

            <input
              id={`${uuid}-customer-policyNumber-id`}
              className="w-full uppercase placeholder:normal-case"
              type="text"
              placeholder="#"
              {...registrationPanelOneRegister("policyNumber", {
                required: t("CustomerRegister-step-1-form-error-4"),
              })}
              aria-labelledby={``}
            />
            {registrationPanelOneErrors.policyNumber && (
              <FormInputError
                id={`${uuid}-policyNumber-error`}
                errorMessage={registrationPanelOneErrors.policyNumber.message}
              />
            )}
            <p className="text-xs text-theme-text-tertiary mb-1">
              {t("CustomerRegister-step-1-form-label-4")}
            </p>
          </div>

          {policyHolder === "entity" && (
            <div className="md:gap-6">
              <label
                id={`${uuid}-customer-businessName-id`}
                className="text-base font-semibold"
              >
                {t("CustomerRegister-step-1-form-label-5")}
              </label>
              <input
                id={`${uuid}-ID_businessName`}
                className="w-full mb-4"
                type="text"
                placeholder={t(
                  "CustomerRegister-step-1-form-label-4-for-entity"
                )}
                {...registrationPanelOneRegister("businessName", {
                  required: {
                    value: true,
                    message: t("CustomerRegister-step-1-form-error-5"),
                  },
                })}
                aria-labelledby={`${uuid}-customer-businessName-id`}
              />
              {registrationPanelOneErrors.businessName && (
                <FormInputError
                  id={`${uuid}-businessName-error`}
                  errorMessage={registrationPanelOneErrors.businessName.message}
                />
              )}
            </div>
          )}

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {policyHolder === "individual" && (
              <>
                <div>
                  <label id={`${uuid}-firstname-label`}>
                    {t("CustomerRegister-step-1-form-label-7")}
                  </label>
                  <input
                    id={`${uuid}-firstname`}
                    className="w-full"
                    type="text"
                    placeholder={t("CustomerRegister-step-1-Firstname")}
                    {...registrationPanelOneRegister("firstname", {
                      required: "Please enter your First Name",
                      maxLength: {
                        value: 50,
                        message: t("CustomerRegister-step-1-form-error-6"),
                      },
                      pattern: {
                        value: /^[A-Za-z-' ]{1,50}$/,
                        message: t("CustomerRegister-step-1-form-error-7"),
                      },
                    })}
                    aria-labelledby={`${uuid}-firstname-label`}
                  />
                  {registrationPanelOneErrors.firstname && (
                    <FormInputError
                      id={`${uuid}-firstname-error`}
                      errorMessage={
                        registrationPanelOneErrors.firstname.message
                      }
                    />
                  )}
                </div>
                <div>
                  <label id={`${uuid}-lastname-label`}>
                    {t("CustomerRegister-step-1-form-label-8")}
                  </label>
                  <input
                    id={`${uuid}-lastname`}
                    className="w-full"
                    type="text"
                    placeholder={t("CustomerRegister-step-1-Lastname")}
                    {...registrationPanelOneRegister("lastname", {
                      required: "Please enter your Last Name",
                      maxLength: {
                        value: 50,
                        message: t("CustomerRegister-step-1-form-error-8"),
                      },
                      pattern: {
                        value: /^[A-Za-z-' ]{1,50}$/,
                        message: t("CustomerRegister-step-1-form-error-9"),
                      },
                    })}
                    aria-labelledby={`${uuid}-lastname-label`}
                  />
                  {registrationPanelOneErrors.lastname && (
                    <FormInputError
                      id={`${uuid}-lastname-error`}
                      errorMessage={registrationPanelOneErrors.lastname.message}
                    />
                  )}
                </div>
                <div className="relative">
                  <label id={`${uuid}-ssn-label`}>
                    {t("CustomerRegister-step-1-form-label-9")}
                  </label>

                  <SSNInput
                    describedby={`${uuid}-ssn-label`}
                    name="ssn"
                    register={registrationPanelOneRegister}
                    setValue={registrationPanelOneSetValue}
                  />

                  <div
                    id={`${uuid}-ssnnote`}
                    className="text-xxs text-theme-text-tertiary mt-1"
                  >
                    {t("CustomerRegister-step-1-form-label-10")}
                  </div>
                  {registrationPanelOneErrors.ssn && (
                    <FormInputError
                      id={`${uuid}-ssn-error`}
                      errorMessage={registrationPanelOneErrors.ssn.message}
                    />
                  )}
                </div>
              </>
            )}

            {policyHolder === "entity" && (
              <div className="relative">
                <label id={`${uuid}-ID_ssn`}>
                  {t("CustomerRegister-step-1-form-label-11")}
                </label>
                <SSNInput
                  name="socialSecurity_EIN"
                  describedby={`${uuid}-ID_ssn`}
                  register={registrationPanelOneRegister}
                  setValue={registrationPanelOneSetValue}
                />
                <div
                  id={`${uuid}-ID_ssn-note`}
                  className="text-xxs text-theme-text-tertiary mt-1"
                >
                  {t("CustomerRegister-step-1-form-label-12")}
                </div>
                {registrationPanelOneErrors.socialSecurity_EIN && (
                  <FormInputError
                    id={`${uuid}-ID_ssnError`}
                    errorMessage={
                      registrationPanelOneErrors.socialSecurity_EIN.message
                    }
                  />
                )}
              </div>
            )}
            {policyHolder === "individual" && (
              <div>
                <label htmlFor={`${uuid}-dob`} className="block">
                  {t("CustomerRegister-step-1-form-label-13")}
                </label>
                <input
                  id={`${uuid}-dob`}
                  type="date"
                  max={moment().add(-1, "days").format("YYYY-MM-DD").toString()}
                  {...registrationPanelOneRegister("dob", {
                    required: t("CustomerRegister-step-1-form-error-10"),
                  })}
                />
                <FormInputError
                  id={`${uuid}-dob-error`}
                  errorMessage={registrationPanelOneErrors.dob?.message}
                />
              </div>
            )}

            <div>
              <label id={`${uuid}-zipcode-label`}>
                {t("CustomerRegister-step-1-form-label-17")}
              </label>
              <div>
                <input
                  id={`${uuid}-zipcode`}
                  type="text"
                  disabled={checkBox}
                  placeholder={t("CustomerRegister-step-1-Zipcode")}
                  {...registrationPanelOneRegister("zipCode", {
                    required: {
                      value: !checkBox,
                      message: t("CustomerRegister-step-1-form-error-11"),
                    },
                    pattern: {
                      value: /^\d{5}$/,
                      message: t("CustomerRegister-step-1-form-error-12"),
                    },
                    maxLength: {
                      value: 5,
                      message: t("CustomerRegister-step-1-form-error-13"),
                    },
                  })}
                  aria-labelledby={`${uuid}-zipcode-label`}
                />
                {registrationPanelOneErrors.zipCode && !checkBox && (
                  <FormInputError
                    id={`${uuid}-zipcode-error`}
                    errorMessage={registrationPanelOneErrors.zipCode.message}
                  />
                )}
              </div>
              {config.ENABLE_NON_US_USER === "true" && (
                <label className="ui-checkbox mt-2">
                  <input
                    type="checkbox"
                    value={"checkbox"}
                    checked={checkBox}
                    onChange={() => setCheckBox(!checkBox)}
                  />
                  <div className="ui-checkmark">
                    <svg
                      className="ui-icon w-2 h-2 text-white"
                      focusable="false"
                      aria-hidden="true"
                      role="presentation"
                    >
                      <use href="#ui-icon-checkmark"></use>
                    </svg>
                  </div>
                  <span className="font-semibold">
                    {t("CustomerRegister-step-1-form-label-16")}
                  </span>
                </label>
              )}
            </div>

            <div>
              <label id={`${uuid}-phone-label`}>
                <Trans
                  i18nKey="CustomerRegister-step-1-form-label-14"
                  components={{
                    optional: <i className="text-ui-gray-medium" />,
                  }}
                />
              </label>

              <MaskedPhoneNumberInput
                name="phoneNumber"
                describedby={`${uuid}-phone-label`}
                register={registrationPanelOneRegister}
                setValue={registrationPanelOneSetValue}
                required={false}
              />

              {registrationPanelOneErrors.phoneNumber && (
                <FormInputError
                  id={`${uuid}-phone-error`}
                  errorMessage={registrationPanelOneErrors.phoneNumber.message}
                />
              )}
              <span id={`${uuid}-phone-format`} className="sr-only">
                {t("CustomerRegister-step-1-form-label-15")}
              </span>
            </div>
          </div>

          <div className="mt-4 text-right">
            <button
              id="ID_registrationStep1Btn"
              className="ui-btn-primary ui-btn-min-w mt-2"
              aria-expanded="false"
            >
              <Trans
                i18nKey="CustomerRegister-step-1-form-label-18"
                components={{
                  srText: <span className="sr-only"></span>,
                }}
              ></Trans>
            </button>
          </div>
        </form>
      </div>
      <DomainErrorModal
        modalState={modalState}
        setModalState={setModalState}
        errorInfo={errorInfo}
        setCurrentStep={setCurrentStep}
        domainError={domainError}
        setDomainError={setDomainError}
        title={errorTitle}
      />
    </>
  );
};

export default PanelOne;
